import React from 'react';
import { X, TrendingUp, Star, Send } from 'lucide-react';



const OtherBidsModal = ({
  onClose,
  onPlaceBid,
  bids = [],
  highestBid = 0,
  loading = false,
}) => {

  const highest = highestBid;
  

  return (
    <div className="bj-modal-overlay" onClick={onClose}>
      <div className="ob-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ob-modal__header">
          <div className="ob-modal__icon"><TrendingUp size={20} /></div>
          <div>
            <h3 className="ob-modal__title">Other Workers' Bids</h3>
            <p className="ob-modal__sub">See what others offered before placing yours</p>
          </div>
          <button className="ob-modal__close" onClick={onClose}><X size={18} /></button>
        </div>

       <div className="ob-modal__body">
  {bids.length === 0 ? (
    <p className="ob-modal__empty">No bids yet — be the first!</p>
  ) : (
    bids
      .slice()
      .sort((a, b) => a.bidAmount - b.bidAmount)
      .map((bid) => {

        console.log(bid);

        return (
          <div
            key={bid.id}
            className={
              'ob-bid-row' +
              (bid.bidAmount === highest ? ' ob-bid-row--highest' : '')
            }
          >
           <div className="ob-bid-row__left">
  <div className="ob-bid-row__avatar">
    {bid.whserviceprovider?.fullName?.charAt(0)}
  </div>

  <div>
    <div className="ob-bid-row__name">
      {bid.whserviceprovider?.fullName}
    </div>
  </div>
</div>

            <div className="ob-bid-row__amount">
              $ {bid.bidAmount}
            </div>
          </div>
        );
      })
  )}
</div>

        <div className="ob-modal__footer">
          <button className="ob-modal__cancel-btn" onClick={onClose}>Close</button>
          <button className="ob-modal__submit-btn" onClick={onPlaceBid}>
            <Send size={15} /> Place My Bid
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtherBidsModal;